import React from 'react';

import { CatalogIcon } from '@assets/icon';
import { PermissionEnum } from '@modules/permissions/entity';
import { IRouter } from '@routers/interface';

const routerExchangeGifts2: IRouter = {
  path: '/gifts/exchange-gift-2',
  loader: React.lazy(() => import('./index')),
  exact: true,
  name: 'gift.exchange2.router.name', //translate here for breadcrumb and sidebar
  masterLayout: true,
  icon: <CatalogIcon />,
  permissionCode: PermissionEnum.RewardItemsView,
};

export default routerExchangeGifts2;
